var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"mobile-nav"},[_c('div',{staticClass:"mobile-nav__main theme-bg--black-light"},[_vm._t("main-nav")],2),_vm._v(" "),_c('div',{staticClass:"mobile-nav__secondary-nav theme-bg--black-light"},[_vm._t("sub-nav")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }